
import React, { useEffect, useRef, useState } from 'react';
import axiosInstance from '../../axiosConfig';
import '../../styles/PaypalPayment.css'; // Make sure to create and import this CSS file for styling

const PaypalPaymentForm = ({ amount, onPaymentSuccess }) => {
    const buttonContainerRef = useRef(null);
    const [sdkLoaded, setSdkLoaded] = useState(false);

    useEffect(() => {
        const loadPaypalScript = () => {
            return new Promise((resolve, reject) => {
                if (document.getElementById('paypal-sdk')) {
                    resolve();
                    return;
                }
                const script = document.createElement('script');
                script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&currency=USD`;
                script.id = 'paypal-sdk';
                script.onload = () => resolve();
                script.onerror = (error) => reject(error);
                document.body.appendChild(script);
            });
        };

        loadPaypalScript()
            .then(() => {
                setSdkLoaded(true);
            })
            .catch((error) => {
              //  console.error('Failed to load the PayPal SDK script:', error);
            });

        return () => {
            if (buttonContainerRef.current) {
                buttonContainerRef.current.innerHTML = '';
            }
        };
    }, []);

    useEffect(() => {
        const renderPaypalButton = () => {
            if (window.paypal && buttonContainerRef.current && buttonContainerRef.current.children.length === 0) {
                window.paypal.Buttons({
                    createOrder: async (data, actions) => {
                        try {
                            const response = await axiosInstance.post('/api/paypal/pay', {
                                amount: parseFloat(amount),
                                plan: "monthly",
                                returnUrl: `${window.location.origin}/paypal/success`,
                                cancelUrl: `${window.location.origin}/paypal/cancel`,
                            });
                            return response.data.orderID;
                        } catch (error) {
                            //console.error('Error creating order:', error);
                            throw error;
                        }
                    },
                    onApprove: async (data, actions) => {
                        try {
                            await axiosInstance.post('/api/paypal/execute', { token: data.orderID });
                            onPaymentSuccess();
                        } catch (error) {
                            //console.error('Error capturing order:', error);
                        }
                    },
                    onError: (err) => {
                       // console.error('PayPal Checkout onError', err);
                    }
                }).render(buttonContainerRef.current);
            }
        };

        if (sdkLoaded) {
            renderPaypalButton();
        }
    }, [sdkLoaded, amount, onPaymentSuccess]);

    return (
        <div className="paypal-payment-form-container">
            <div className="payment-amount">
                Amount to pay: {amount} USD
            </div>
            <div id="paypal-button-container" ref={buttonContainerRef}></div>
        </div>
    );
};

export default PaypalPaymentForm;
